export default "/images/524db638e7e94e6c7e22cd086023e3c1.avif";